import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Loader as LoaderLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  margin-top: 5px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
`;

const HeaderContainer = styled.div`
  width: 350px;
  display: inline-block;
`;

const OtherDetails = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

const Detail = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const Loader = styled(LoaderLayoutComponent)``;

const Tester = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0px;
`;

const ContainerTextName = styled.div`
  width: 200px;
`;

const ButtonRemove = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    font-size: 14px;
    margin-left: 20px;
    width: 120px;
  }
`;

const ButtonApprove = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 14px;
    margin-left: 20px;
    width: 120px;
  }
`;

const UndoButton = styled(ButtonLayoutComponent.Label)`
  &.ui.button {
    display: flex;
    flex-direction: row;
    pointer-events: all !important;
  }
`;

const Undo = styled(TextLayoutComponent.Muted)`
  color: white;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-top: 20px;
  }
`;

const ContainerSpace = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContainerParticipants = styled.div`
  display: flex;
`;

export {
  ButtonApprove,
  ButtonRemove,
  Container,
  ContainerTextName,
  Detail,
  HeaderContainer,
  Loader,
  OtherDetails,
  Tester,
  Undo,
  UndoButton,
  Button,
  ContainerSpace,
  ContainerParticipants,
};
